import React, { useEffect, useRef } from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import moment from "moment-timezone";
import HighchartsCustomEvents from "highcharts-custom-events";
import { numberWithCommas, mFormatter, kmFormatter, toTitleCase } from "../../../../../Dashboard/Charts/utils";
import ResizeObserver from "resize-observer-polyfill";
HighchartsCustomEvents(Highcharts);

function StoryMediaBreakupChart(props) {
    let chartComponent = useRef(null);
    const legendAlign = props.isIGPage ? "right" : "center";

    useEffect(() => {
        let ro = null;
        // if (!props.isIGPage) {
        ro = new ResizeObserver(() => {
            chartComponent?.current?.chart?.setSize(null, null);
            chartComponent?.current?.chart?.reflow();
        });
        if (props.widgetContainerRef?.current) {
            ro.observe(props.widgetContainerRef?.current);
        }
        // }
        return () => {
            // if (!props.isIGPage) {
            ro.disconnect();
            // }
        };
    }, []);

    const getOptionsPie = () => {
        const data = JSON.parse(JSON.stringify(props.chartData?.data || []));

        const chartOptions = {
            chart: {
                type: "pie",
                backgroundColor: "transparent",
                style: {
                    fontFamily: "'Roboto', sans-serif",
                    fontSize: 12,
                },
            },
            credits: {
                enabled: false,
            },
            lang: {
                noData: "No data.",
            },
            noData: {
                style: {
                    fontWeight: "bold",
                    fontSize: "15px",
                    color: "#303030",
                },
                position: {
                    align: "center",
                },
            },
            title: {
                text: " ",
            },
            series: [{ data }],
            legend: {
                enabled: props.showLegend,
                align: legendAlign,
                itemStyle: {
                    fontWeight: 500,
                    fontFamily: "'Roboto', sans-serif",
                    textTransform: "normal",
                },
                alignColumns: false,
            },

            plotOptions: {
                pie: {
                    shadow: false,
                    showInLegend: true,
                    dataLabels: {
                        enabled: props.showLabel,
                        distance: "10%",
                        format: "{point.name}: {point.percentage:.1f} %",
                        style: {
                            fontWeight: 400,
                        },
                    },
                    point: {
                        events: {
                            contextmenu: function (e) {
                                e.preventDefault();
                                self.props.addContextMenuListener(e.x, e.y, this);
                            },
                        },
                    },
                },
            },
            xAxis: {
                lineWidth: 0,
            },
            yAxis: {
                lineWidth: 0,
            },
            tooltip: {
                formatter: function () {
                    return `<span>${this.point.name}</span> <br/> <span>Count |  <b>${this.point.percentage.toFixed(1)}% | </b>
                   <span> <b>${numberWithCommas(this.point.doc_count)}</b> / <b>${numberWithCommas(props.chartData.total)}</b></span>
                    </span>`;
                },

                backgroundColor: "#fff",
                borderRadius: 6,
            },
        };

        return chartOptions;
    };

    const getOptionsBar = () => {
        const data = JSON.parse(JSON.stringify(props.chartData?.data || []));

        const chartBarOptions = {
            chart: {
                type: "bar",
                backgroundColor: "transparent",
                style: {
                    fontFamily: "'Roboto', sans-serif",
                    fontSize: 12,
                },
            },
            credits: {
                enabled: false,
            },
            lang: {
                noData: "No data.",
            },
            noData: {
                style: {
                    fontWeight: "bold",
                    fontSize: "15px",
                    color: "#303030",
                },
                position: {
                    align: "center",
                },
            },
            title: {
                text: " ",
            },
            series: data,
            legend: {
                enabled: props.showLegend,
                align: legendAlign,
                itemStyle: {
                    fontWeight: 500,
                    fontFamily: "'Roboto', sans-serif",
                    textTransform: "normal",
                },
                alignColumns: false,
            },

            plotOptions: {},
            xAxis: {
                // categories: this.props.chartData.LocationWithData || [],
                type: "category",
                lineWidth: 1,
                labels: {
                    useHTML: true,
                    style: { overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" },
                },
            },
            yAxis: {
                gridLineWidth: props.showGridLines ? 2 : 0,
                gridLineDashStyle: "shortdash",
                gridLineColor: "#ccd6eb",
                lineColor: "#ccd6eb",
                lineWidth: 1,
                title: "",
            },
            tooltip: {
                formatter: function () {
                    return `<span>${this.point.name}</span> <br/> <span>Count |  <b>${((this.point.doc_count * 100) / props.chartData.total).toFixed(0)}% | </b>
                   <span> <b>${numberWithCommas(this.point.doc_count)}</b> / <b>${numberWithCommas(props.chartData.total)}</b></span>
                    </span>`;
                },

                backgroundColor: "#fff",
                borderRadius: 6,
            },
        };

        return chartBarOptions;
    };

    const getOptions = () => {
        if (props.graphType === "pie") return getOptionsPie();
        else return getOptionsBar();
    };

    return props.graphType === "pie" ? (
        <HighchartsReact
            highcharts={Highcharts}
            options={getOptions()}
            ref={chartComponent}
            containerProps={{ style: { width: "100%", height: props.isIGPage ? "100%" : "calc(100% - 10px)" } }}
        />
    ) : (
        <HighchartsReact
            highcharts={Highcharts}
            options={getOptions()}
            ref={chartComponent}
            containerProps={{ style: { width: "100%", height: props.isIGPage ? "100%" : "calc(100% - 10px)" } }}
        />
    );
}
export default StoryMediaBreakupChart;
